import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  Botao,
  Breadcrumb,
  Cabecalho,
  ContainerAcoes,
  Filtro,
  IconeEditar,
  TabelaDados,
  TabelaRef,
  TabelaResposta,
  Tooltip,
  AutenticacaoContainer,
  Visao
} from 'src/componentes'
import {
  Container,
  Form,
  ContainerDados75,
  Dados
} from 'src/componentes/styles/filtro'
import {
  DataInputUnform,
  InputUnform,
  SelectOpcao,
  SelectUnform
} from 'src/componentes/unform'
import { RotasCursoCertificacao } from 'src/rotas'
import { Api } from 'src/servicos'
import {
  TipoOrdenacao,
  CursoSituacao,
  ModalidadeCursoCertificacao,
  DadosPesquisaCursoCertificacao
} from 'src/tipos'

import { ContainerCertificacao } from '../styles'
import { OPCOES_MODALIDADE } from './opcoes-select'
import { TabelaComEstilos } from './styles'

export const PaginaCursosCertificacao: React.FC = () => {
  const { visao } = AutenticacaoContainer.useContainer()
  const usuario = localStorage.getItem('@ipgs/usuario')
  const usuarioObj = JSON.parse(usuario)
  const usuarioId = usuarioObj.id

  const history = useHistory()
  const [
    dadosPesquisa,
    definirDadosPesquisa
  ] = useState<DadosPesquisaCursoCertificacao>(null)
  const tabelaRef = useRef<TabelaRef>()
  const [paginas, definirPaginas] = useState(null)
  const [usuarioOpcoes, definirUsuarioOpcoes] = useState<SelectOpcao[]>([])

  const obterDados = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (paginas !== null) {
      numeroPaginas = paginas
    }

    const parametrosComuns = {
      usuarioId,
      visao,
      nome: dadosPesquisa?.nome,
      modalidade: dadosPesquisa?.modalidade,
      usuarioPerfilFiltro: dadosPesquisa?.usuarioPerfilFiltro,
      dataCriacaoCurso: dadosPesquisa?.dataCriacaoCurso,
      chaveOrdenacao,
      ordem
    }

    const requisitarCursos = async (
      pagina: number,
      quantidade: number,
      isPaginated: number
    ) =>
      Api.RequisitarListaCursosCertificacao(
        parametrosComuns.usuarioId,
        parametrosComuns.visao,
        isPaginated,
        parametrosComuns.nome,
        parametrosComuns.usuarioPerfilFiltro,
        parametrosComuns.modalidade,
        parametrosComuns.dataCriacaoCurso,
        pagina,
        quantidade,
        parametrosComuns.chaveOrdenacao,
        parametrosComuns.ordem
      )

    const dados = await requisitarCursos(numeroPaginas, quantidadePorPagina, 1)
    if (!dados) return null

    if (visao !== Visao.ParceiroCertificacao) {
      const dadosTodos = await requisitarCursos(1, 0, 0)
      const usuariosUnicos = dadosTodos.registros
        .map(dado => ({
          id: dado.usuarioPerfilId,
          texto: dado.usuarioPerfilNome
        }))
        .filter(
          (valor, indice, self) =>
            self.findIndex(v => v.id === valor.id) === indice
        )

      definirUsuarioOpcoes([{ id: '', texto: 'Todos' }, ...usuariosUnicos])
    }

    definirPaginas(null)

    return {
      Dados: dados.registros,
      Paginacao: {
        Pagina: dados.opcoesPaginacao.pagina,
        TotalRegistros: dados.opcoesPaginacao.totalRegistros
      }
    } as TabelaResposta
  }

  useEffect(() => {
    if (dadosPesquisa === null) return
    tabelaRef.current.IrParaPagina()
    tabelaRef.current.CarregarDados()
  }, [dadosPesquisa])

  const acaoPesquisa = (dados: DadosPesquisaCursoCertificacao) => {
    if (dados !== null && paginas !== 1) {
      definirPaginas(1)
    }
    definirDadosPesquisa(dados)
  }

  return (
    <ContainerCertificacao>
      <Cabecalho>
        <Breadcrumb
          titulo="Pesquisa de Cursos"
          atalhos={[
            {
              texto: 'Acadêmico'
            },
            {
              texto: 'Cursos'
            }
          ]}
        />
        {visao === Visao.ParceiroCertificacao && (
          <Botao
            type="button"
            texto="Incluir"
            tema="Secundario"
            onClick={() => history.push(RotasCursoCertificacao.Cadastro)}
          />
        )}
      </Cabecalho>
      <Filtro>
        <Form
          dadosIniciais={{
            situacao: CursoSituacao[CursoSituacao.Todos],
            modalidade: 'Todas'
          }}
          acaoSucesso={acaoPesquisa}
        >
          <Container>
            <ContainerDados75>
              <InputUnform type="text" name="nome" label="Nome do Curso" />
            </ContainerDados75>
            <ContainerDados75>
              <SelectUnform
                id="slct_modalidade"
                name="modalidade"
                label="Modalidade do Curso"
                placeholder="Selecione"
                opcoes={OPCOES_MODALIDADE} // {OPCOES_MODALIDADE}
              />
            </ContainerDados75>
            {visao === Visao.ParceiroCertificacao && (
              <ContainerDados75>
                <DataInputUnform
                  name="dataCriacaoCurso"
                  label="Data de criação"
                />
              </ContainerDados75>
            )}
          </Container>
          <Container>
            {visao !== Visao.ParceiroCertificacao && (
              <>
                <ContainerDados75>
                  <SelectUnform
                    id="slct_usuario"
                    name="usuarioPerfilFiltro"
                    label="Parceiro"
                    margemInferior={false}
                    opcoes={usuarioOpcoes}
                  />
                </ContainerDados75>
                <ContainerDados75>
                  <DataInputUnform
                    name="dataCriacaoCurso"
                    label="Data de criação"
                  />
                </ContainerDados75>
              </>
            )}
          </Container>
          <Botao
            type="submit"
            id="btn-aplicar-filtro"
            texto="Aplicar filtro"
            tema="Link"
          />
        </Form>
      </Filtro>
      <Dados>
        <TabelaComEstilos
          ref={tabelaRef}
          Colunas={[
            {
              Chave: 'nome',
              Texto: 'Nome',
              ComOrdenacao: true
            },
            {
              Chave: 'modalidade',
              Texto: 'Modalidade',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) =>
                ModalidadeCursoCertificacao[linha.modalidade]
            },
            {
              Chave: 'cargaHoraria',
              Texto: 'Carga horária',
              ComOrdenacao: true
            },
            {
              Chave: 'duracao',
              Texto: 'Duração',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) =>
                `${linha.duracao} ${linha.duracao === 1 ? 'mês' : 'meses'}`
            },
            {
              Chave: 'divisao',
              Texto: 'Divisão',
              ComOrdenacao: true
            },
            ...(visao !== Visao.ParceiroCertificacao
              ? [
                  {
                    Chave: 'usuarioPerfilNome',
                    Texto: 'Nome do parceiro',
                    ComOrdenacao: false
                  }
                ]
              : []),
            {
              Chave: 'acoes',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <ContainerAcoes>
                  <button
                    type="button"
                    data-tip="Editar"
                    data-for={`${linha.id}-tooltip-editar`}
                    onClick={() =>
                      history.push(
                        `${RotasCursoCertificacao.Edicao}/${linha.id}`,
                        {
                          modalidade: linha.modalidade
                        }
                      )
                    }
                    onContextMenu={() => {
                      const rota = window.open(
                        `${RotasCursoCertificacao.Edicao}/${linha.id}/${linha.modalidade}`
                      )
                      rota.focus()
                    }}
                  >
                    {IconeEditar}
                  </button>
                  <Tooltip
                    id={`${linha.id}-tooltip-editar`}
                    place="bottom"
                    offset={{ top: 10 }}
                  />
                </ContainerAcoes>
              )
            }
          ]}
          ObterDados={obterDados}
          ComPaginacao
        />
      </Dados>
    </ContainerCertificacao>
  )
}

export { default as PaginaCadastroCursosCertificacao } from './cadastro'
